/*
 * @description: 主页面顶部配置项，以下为示例代码，使用时请修改为自己需要的配置项，不要修改本文件名或文件所在路径
 * @author: xuy
 * @since: 2020-03-23 09:46:07
 * @version: 1.0
 */
import Screenfull from '@/framework/components/Screenfull'
import SizeSelect from '@/framework/components/SizeSelect'
import HeaderSearch from '@/framework/components/HeaderSearch'

const uiConfig = {
  logoSrc: require('@/app/common/image/nav/icon.png'),
  title: 'SCM采购供应链供应商门户',
  // 操作按钮，靠右侧的，组件为import的对象
  headerRightMenu: [
    {
      // 悬浮提示
      tips: '提示1',
      // 使用的组件对象
      component: HeaderSearch,
      // 组件名，要与组件定义的名称一致，动态加载组件时使用
      componentName: 'HeaderSearch'
    },
    {
      tips: '提示2',
      component: Screenfull,
      componentName: 'Screenfull'
    },
    {
      tips: '提示3',
      component: SizeSelect,
      componentName: 'SizeSelect'
    }
  ],
  avatarButton: {
    // 是否显示头像图标，默认为ture
    showAvatar: true,
    // 是否显示头像图标后的姓名，默认为ture
    showName: true,
    // 是否显示圆形图标，默认为true
    circle: true,
    // 默认头像，可以是图片url，也可以是引入资源
    // defaultAvatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    defaultAvatar: require('@/app/system-mgt/assets/common/default-avatar.jpg'),
    menu: [

      {
        name: '菜单3(响应事件)',
        // 响应事件举例，实际写的时候最好不要在这里直接写逻辑，使用import导入
        event: function() {
          // alert('点击了菜单3')
        }
      }
    ]
  }

}

export default uiConfig
